import React, { Component } from "react";
import PubSub from 'pubsub-js';

import {
    Drawer,
    CircularProgress,
    IconButton,
    Tooltip,
} from '@material-ui/core/';

import LayoutIcon from '@material-ui/icons/OpenWith';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import DetailsIcon from '@material-ui/icons/List';
import RefreshIcon from '@material-ui/icons/Refresh';
import StopIcon from '@material-ui/icons/Stop';

import CytoscapeComponent from 'react-cytoscapejs';
import cytoscape from 'cytoscape';
import { DialogTester } from '../utils/DialogTester';

import JSONView from '../views/JSONView';
var gridGuide = require('cytoscape-grid-guide');
gridGuide(cytoscape);

const layoutType = {
    name: 'breadthfirst',
    directed: true,
    padding: 10,
    avoidOverlap: true,
    circle: false
};

let defaultNodes = [
    { "data": { id: 'start', shape: 'ellipse', color: { bg: 'blue', text: 'white' }, size: { width: 50, height: 40 } } },
    { "data": { id: 'end', shape: 'ellipse', color: { bg: 'blue', text: 'white' }, size: { width: 50, height: 40 } } },

];

class DialogReportView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nodes: defaultNodes,
            edges: [
            ],
            progress: null,
            progressMessage: null,
            error: null,
            drawAnswerPaths: false,
            showPermutations: false
        };
        this.dialogTester = new DialogTester(props.appContext);

    }

    componentDidMount() {
        this.token = PubSub.subscribe('PLAN_TOPIC', (msg, data) => {
            if (data.action === 'PlanSelected') {
                this.generatePermuations();
            }
        });
        this.generatePermuations();
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
        this.cancelGenerate();
    }

    generatePermuations() {
        this.setState({ progress: <CircularProgress size={20} />, error: null, progressMessage: null });
        this.dialogTester.generatePermuations((progressMessage, permutations ) => {
            this.setState({ progressMessage, permutations }, this.drawPermutations.bind(this));
        }).then((result) => {
            console.log(`permutations `, result)
            this.setState({ permutations: result, progress: null }, this.drawPermutations.bind(this));

        }).catch((err) => {
            console.error("generatePermuations error:", err);
            this.setState({ progress: null, error: err.message });
        })
    }

    cancelGenerate() {
        this.setState({ progress: null, error: 'Cancelled...' });
        this.dialogTester.cancelGeneratePermuations();
    }

    layout() {
        if (this.cy) {
            let layout = this.cy.layout(layoutType);
            layout.run();
        }
    }

    addLink(edges, source, target) {
        let id = `${source}-${target}`
        if (edges.find((edge) => edge.data.id === id)) return;
        edges.push({ data: { id, source, target } });
    }

    addNode(nodes, id) {
        if (nodes.find((node) => node.data.id === id)) return;
        nodes.push({ data: { id } });
    }

    showPermutations() {
        let { permutations, showPermutations } = this.state;
        let dialog = <Drawer variant="persistent" anchor="right" open={showPermutations}>
            <JSONView data={permutations} onClose={() => this.setState({showPermutations: false})} />
        </Drawer>;
        this.setState({ dialog });
    }

    closeDialog() {
        this.setState({ dialog: null });
    }



    drawPermutations() {
        let { permutations } = this.state;
        let nodes = JSON.parse(JSON.stringify(defaultNodes));
        let edges = [];
        delete edges['link1'];
        if (Array.isArray(permutations))
            permutations.forEach(permutation => {
                //only draw permutations 
                if (permutation.complete) {
                    let journals = permutation.journals;
                    if (Array.isArray(journals)) {

                        let length = journals.length;
                        for (let index = 0; index < length; index++) {

                            let from = null;
                            let to = null;
                            //wire to the start
                            if (index === 0) {
                                from = 'start';
                                to = journals[index].questionId;

                                //wire the nodes
                                to = journals[index].questionId;
                                this.addNode(nodes, to);
                                this.addLink(edges, from, to);

                            } else if (index === length - 1) {//wire the end
                                //onlu add the end if complete 
                                //wire the nodes
                                from = journals[index - 1].questionId;
                                to = journals[index].questionId;
                                this.addNode(nodes, from);
                                this.addNode(nodes, to);
                                this.addLink(edges, from, to);

                                if (permutation.complete) {
                                    from = journals[index].questionId;
                                    to = 'end'
                                    this.addNode(nodes, from);
                                    this.addLink(edges, from, to);
                                } 
                            } else {

                                //wire the nodes
                                from = journals[index - 1].questionId;
                                to = journals[index].questionId;
                                this.addNode(nodes, from);
                                this.addNode(nodes, to);
                                this.addLink(edges, from, to);
                            }
                        }
                    }
                }

            });

        this.setState({ nodes, edges });
    }

    cancelDialog() {
        this.setState({ dialog: null });
    }

    onFilesError(error, file) {
        console.log("onFilesError:", error, file);
    }
    export() {
        if (this.cy) {
            let pngExport = this.cy.png({ output: "blob", full: true, bg: 'white' });
            const fileDownload = require('js-file-download');
            fileDownload(pngExport, `diagram.png`);
        }
    }



    render() {
        const { error, progressMessage, progress, dialog, nodes, edges, showPermutations, permutations } = this.state;

        const elements = CytoscapeComponent.normalizeElements({
            nodes,
            edges
        });

        if (this.cy) {
            this.cy.gridGuide({
                drawGrid: true,
                guidelinesStyle: {
                    strokeStyle: "black",
                    horizontalDistColor: "#ff0000",
                    verticalDistColor: "green",
                    initPosAlignmentColor: "#0000ff",
                }
            })

            const layout = this.cy.layout(layoutType);
            layout.run();
        }
        return (
            <div style={styles.div}>
                <Tooltip title='Show Permutations Details'><IconButton onClick={() => this.setState({ showPermutations: !showPermutations })}><DetailsIcon /></IconButton></Tooltip>
                <Tooltip title='Resize Layout'><IconButton onClick={() => this.layout()}><LayoutIcon /></IconButton></Tooltip>
                <Tooltip title='Export Image'><IconButton onClick={this.export.bind(this)}><DownloadIcon /></IconButton></Tooltip>
                <Tooltip title='Refresh'><IconButton disabled={progress !== null} onClick={this.generatePermuations.bind(this)}>{progress || <RefreshIcon />}</IconButton></Tooltip>
                <Tooltip title='Cancel Generation'><IconButton disabled={progress === null} onClick={this.cancelGenerate.bind(this)}><StopIcon /></IconButton></Tooltip>
                {error || progressMessage}
                <div id="cy">
                    <CytoscapeComponent
                        cy={(cy) => { this.cy = cy }}
                        layout={layoutType}
                        elements={elements}
                        style={{ width: '95%', height: 1000 }}
                        stylesheet={[
                            {
                                "selector": "node",
                                "style": {
                                    "text-valign": "center",
                                    "text-halign": "center",
                                    "shape": "ellipse",
                                    'background-color': "white",
                                    'border-color': 'black',
                                    'border-width': 2,
                                    "label": "data(id)",
                                    "width": 250,
                                    "height": 70,
                                }
                            },
                            {
                                "selector": "node[color]",
                                "style": {
                                    "text-valign": "center",
                                    "text-halign": "center",
                                    'background-color': "data(color.bg)",
                                    'border-color': 'white',
                                    'border-width': 2,
                                    "color": "data(color.text)",
                                    "label": "data(id)",
                                }
                            },
                            {
                                "selector": "node[size]",
                                "style": {
                                    "text-valign": "center",
                                    "text-halign": "center",
                                    "width": 'data(size.width)',
                                    "height": 'data(size.height)'
                                }
                            },
                            {
                                "selector": "node[shape]",
                                "style": {
                                    "text-valign": "center",
                                    "text-halign": "center",
                                    "shape": "data(shape)",
                                    "label": "data(id)",
                                }
                            },
                            {
                                "selector": "edge",
                                "style": {
                                    "width": 1,
                                    "curve-style": "straight",
                                    "target-arrow-shape": "triangle"
                                }
                            }, {
                                "selector": "edge.hollow",
                                "style": {
                                    "target-arrow-fill": "hollow"
                                }
                            }
                        ]}
                    />
                </div>
                {dialog}
                <Drawer variant="persistent" anchor="right" open={showPermutations}>
                    <JSONView data={permutations} onClose={() => this.setState({showPermutations: false})} />
                </Drawer>
            </div>);
    }

}


const styles = {
    div: {
        margin: 10
    },

    button: {
        margin: 10
    },
    jsonPaper: {
        margin: 5,
        padding: 10,
        width: 1500,
        height: 1000,
        borderRadius: 6
    }
};


export default DialogReportView;
